import { useEffect, useState } from "react";
import api from "@/lib/api";
import { FadeUp } from "./Reveal";

export const InstagramStrip = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api
      .get("/instagram/media?limit=8")
      .then((r) => setItems(r.data.data || []))
      .catch(() => {});
  }, []);

  if (!items.length) return null;

  return (
    <section id="instagram" className="px-6 md:px-12 py-28 md:py-40 bg-[#0A0A0A] border-t border-white/5" data-testid="instagram-section">
      <FadeUp className="mb-14 flex flex-col md:flex-row md:items-end justify-between gap-6">
        <div>
          <p className="text-xs tracking-[0.4em] uppercase text-[#C9A26B] mb-4">Journal</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter text-[#F5F4F0] leading-[1.05]">
            Latest from <span className="font-accent italic text-[#C9A26B]">Instagram</span>
          </h2>
        </div>
        <a
          href="https://instagram.com/tapeshift_weddings"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="instagram-follow-link"
          className="text-xs tracking-[0.3em] uppercase text-[#A3A3A3] hover:text-[#C9A26B] transition-colors duration-300"
        >
          @tapeshift_weddings
        </a>
      </FadeUp>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {items.map((it, i) => (
          <FadeUp key={it.id} delay={(i % 4) * 0.08}>
            <a
              href={it.permalink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`instagram-item-${i}`}
              className="group block relative overflow-hidden rounded-sm aspect-square"
            >
              <img
                src={it.media_url}
                alt={it.caption ? it.caption.slice(0, 120) : "TapeShift wedding photograph"}
                loading="lazy"
                className="photo-tone w-full h-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-[#0A0A0A]/30 group-hover:opacity-0 transition-opacity duration-700" />
            </a>
          </FadeUp>
        ))}
      </div>
    </section>
  );
};
